import { Route } from "@angular/router";
import { ExecuteExternalProcessComponent } from "./execute-external-process.component";
const routes: Route[] = [
  {
    path: "contratacion-formulario",
    component: ExecuteExternalProcessComponent,
    children: [
      {
        path: "finish",
        loadComponent: () => import("./finish-view/finish-view.component").then((c) => c.FinishViewComponent)
      },
      {
        path: "formulario",
        loadComponent: () => import("../ejecutar-procesos/manual/start-process/start-process.component").then((c) => c.StartProcessComponent)
      }
    ]
  }
];

export { routes as ExecuteExternalProcessRoutes };